<template>
  <Header/>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-12 m-0 no-max-w home-div">
          <Toast/>

          <AstopiaTable ref="astopiaTable" :columns="columns" :url="'/admin/rag/relationship/list'"
                        :default-post-data="'?test=test'"
                        :axiosDataName="'response'" :sort-field="''" :totalDataName="'totalRecords'"
                        @detail-see="detailSee" @detail-see2="detailSee2" @delet-see="deleteSee" @add-button="addPublicFigure" :addButton="'Add Relationship Type'" :dataPagination="false"  :optionsList="optionsList" :selectedObj3="true"/>

          <EditModal
              :show="showEditModal"
              modalTitle="Edit Rag"
              modalWidth="50%"
              :formFields="[
                { label: 'Relation Ship', type: 'text', model: 'relationShip', placeholder: 'Enter relationShip', required: true },
                { label: 'Value', type: 'number', model: 'value', placeholder: 'Enter value', required: true, popover: true, popoverText: 'Tüm diller de value değerleri aynı olması lazım' },
                { label: 'Language', type: 'select', model: 'language', options: optionsList, value: 'id', text: 'name', required: true},
              ]"
              :detailEndpoint="`/admin/rag/relationship/get/${selectedObjId}`"
              @saveEndpoint="editObj"
              method="put"
              :totalDataName="'response'"
              :isOnlydata="true"
              @hide="showEditModal = false"
          />


          <CreateModal
              :show="showCreateModal"
              modalTitle="Create relationship type"
              modalWidth="50%"
              :formFields="[
                { label: 'Relation Ship', type: 'text', model: 'relationShip', placeholder: 'Enter relationShip', required: true },
                { label: 'Value', type: 'number', model: 'value', placeholder: 'Enter value', required: true, popover: true, popoverText: 'Tüm diller de value değerleri aynı olması lazım'},
                { label: 'Language', type: 'select', model: 'language', options: optionsList, id: 'id', value: 'name', required: true},
              ]"
              @saveEndpoint="createObj"
              method="post"
              @hide="showCreateModal = false"
              :informationButton="'Information'"
              :informationButtonLink="'https://docs.google.com/document/d/18HKWFxQgRUA03kvp2fIVbnX54pSCz7JUW8cO0vo83o4/edit?tab=t.0'"
              @success="refreshTable"
          />



          <DeleteModal
              :show="showDeleteModal"
              :itemId="selectedDeleteId"
              modalTitle="Delete relationship type"
              deleteMessage="Are you sure you want to delete this relationship type?"
              confirmButtonText="Yes"
              :deleteEndpoint="`/admin/rag/relationship/delete/${selectedDeleteId}`"
              @update:isVisible="showDeleteModal = false"
              @delete-success="refreshTable"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Header from "@/components/Header.vue";
import AstopiaTable from "@/components/Tables/AstopiaTable.vue";
import dayjs from "dayjs";
import "@vuepic/vue-datepicker/dist/main.css";
import Toast from 'primevue/toast';
import {mapGetters} from "vuex";
import dist from "vue-sweetalert2/dist";

var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

export default {
  name: "Users",
  components: {
    Header,
    Toast,
    AstopiaTable
  },
  data() {
    const schema = {
      price: "required|numeric|regex",
    };

    return {
      loading: false,
      totalRecords: 0,
      content: [],
      filters: {
        global: {value: null},
        name: {value: null},
        isPublicFigure: {value: true}
      },
      contentLazyParams: {},
      schema,
      houses: [],
      signs: [],
      genders: [{id: 1, name: "Man"}, {id: 2, name: "Woman"}, {id: 3, name: "Other"}],
      showEditBirthdateModal: false,
      selectedObjId: null,
      showEditModal: false,
      showCreateModal: false,
      showDeleteModal: false,
      selectedDeleteId: null,
      editUserModel: {},
      messages: [],
      messageCount: 0,
      saveButtonLoading: false,
      showPublicFigureModal: false,
      newPublicFigureModel: {},
      languages: [],
      countries: [],
      cities: [],
      states: [],
      optionsList: [],
      columns: [
        {field: "relationShip", header: "Relation Ship", functionType: "none", selected: true},
        {field: "value", header: "Value", functionType: "none", selected: true},
        {field: "language", header: "Language", functionType: "none", selected: true},
        {field: "isActive", header: "Is Active", functionType: "bool", selected: true},
        {field: "Actions", header: "Actions", functionType: "crud", edit: true, delete: true, selected: true},
      ],
      data:{
        "relationShip": "string",
        "value": 0,
        "language": "string",
        "isActive": true
      },
      dataUpdate:{
        "relationShip": "string",
        "value": 0,
        "language": "string",
        "isActive": true
      }
    };
  },
  created() {
    this.$appAxios.get("admin/global/supported-languages")
        .then(resp => {
          this.optionsList = resp.data
        })
        .catch(err => {
          console.log(err)
        });
  },
  computed: {
    dist() {
      return dist
    },
    ...mapGetters(['occupations', 'signs', 'houses', 'relationships', 'occupationIds', 'relationshipIds']),
  },
  methods: {
    openEditModal(rowData) {
      this.editUserModel = rowData;
      this.showEditBirthdateModal = true;
    },
    deleteSee(report) {
      this.selectedDeleteId = report.id

      this.showDeleteModal = true
    },
    detailSee(obj) {
      this.selectedObjId = obj.id
      this.showEditModal = true
    },
    detailSee2(obj){
      this.$router.push({name:"ReportImages", params:{id:obj.id, language:obj.language}})
    },
    getLookups() {
      this.$router.push('/get-lookups')
    },
    editObj(obj) {

      this.dataUpdate.relationShip = obj.relationShip;
      this.dataUpdate.value = obj.value;
      this.dataUpdate.language = obj.language;
      this.dataUpdate.isActive = obj.isActive;

      const headers = {
        "Accept-Language": obj?.language,
      };

      this.$appAxios.put(`/admin/rag/relationship/update/${this.selectedObjId}`, this.dataUpdate, { headers }).then(() => {

        this.refreshTable()
        this.showEditModal = false
      }).catch(err => {
        console.log(err)
        this.showEditModal = false
      })
    },
    createObj(obj) {
      this.data.relationShip = obj.relationShip;
      this.data.value = obj.value;
      this.data.language = obj.language;
      this.data.isActive = true;

      const headers = {
        "Accept-Language": obj?.language,
      };

      this.$appAxios.post("/admin/rag/relationship/create", this.data, {headers}).then(() => {
        this.refreshTable()
        this.showCreateModal = false
      }).catch(() => {
        this.showCreateModal = false
      })
    },
    addPublicFigure() {
      this.showCreateModal = true
    },
    refreshTable() {
      this.$refs.astopiaTable.getData();
      this.$refs.astopiaTable.getObj();
    }
  },
};
</script>
<style scoped>
.p-button-sm {
  height: 35px;
  width: 35px;
  font-size: 0.875rem;
  padding: 0.7rem;
}

.p-disabled,
.p-component:disabled {
  opacity: 0.8;
}

.p-dropdown {
  min-width: 200px;
}
</style>